<div *ngIf="isLoading | async" class="loading-indicator">
    <div class="centerspinner">
        <div class="spinnericon">
            <mat-progress-spinner style="position:absolute" class="md-accent" [color]="color" [mode]="mode" [value]="value">
            </mat-progress-spinner>
        </div>
    </div>
</div>
